import type { EmbryoGenomicResult } from "@src/packages/cycles/hooks/useEmbryoReport";

export type EmbryoResultFilter = "all" | EmbryoGenomicResult["result"];

type SearchableEmbryo = Pick<
  EmbryoGenomicResult,
  "embryoNumber" | "sampleId" | "grade" | "karyotype" | "comments" | "result"
>;

export function filterEmbryoReportResults<T extends SearchableEmbryo>(
  embryos: readonly T[],
  query: string,
  resultFilter: EmbryoResultFilter,
): T[] {
  const normalizedQuery = query.trim().toLocaleLowerCase();

  return embryos.filter((embryo) => {
    if (resultFilter !== "all" && embryo.result !== resultFilter) {
      return false;
    }

    if (!normalizedQuery) return true;

    return [
      String(embryo.embryoNumber),
      embryo.sampleId,
      embryo.grade,
      embryo.karyotype,
      embryo.comments,
    ]
      .filter((value): value is string => Boolean(value))
      .some((value) => value.toLocaleLowerCase().includes(normalizedQuery));
  });
}
